// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"730":"d0054848","798":"849a8122"}[chunkId] + ".chunk.css";
};